import { BaseErrorResponse } from '../@api/Sylius';
import {
    FetchResultClientError,
    FetchResultError,
    FetchResultSyliusError,
    FetchResultSyliusErrorType,
} from '../FetchResult/FetchResult';

export const isNotFoundErrorResponse = (error: unknown): error is string => (
    (error as string) === 'Not found'
);

export const isBaseErrorResponse = (error: unknown): error is BaseErrorResponse => (
    !!(error as BaseErrorResponse)['hydra:title']
);

export const isFetchResultErrorResponse = (error: unknown): error is FetchResultError => (
    !!(error as FetchResultError).detail
);

export const isFetchResultClientErrorResponse = (error: unknown): error is FetchResultClientError => (
    !!(error as FetchResultClientError).message
);

export const isFetchResultSyliusErrorResponse = (error: unknown): error is FetchResultSyliusError => {
    const typedError = error as FetchResultSyliusError;
    const syliusErrorTypes = Object.keys(FetchResultSyliusErrorType);

    return syliusErrorTypes.includes(typedError.error.type);
};
